module.exports = __webpack_public_path__ + "img/3d@2x.d5fcb95e.png";